import { Mic } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useSession } from '@/session/store';

/**
 * Hold to talk. Pointer capture rather than a click: the utterance ends on release, and without it
 * a drag off the button would leave the microphone open with no keyup coming.
 */
export function MicButton() {
  const armed = useSession((state) => state.micArmed);
  const live = useSession((state) => state.micLive);
  const level = useSession((state) => state.micLevel);
  const startMic = useSession((state) => state.startMic);
  const stopMic = useSession((state) => state.stopMic);

  return (
    <button
      type="button"
      aria-label="Hold to talk"
      aria-pressed={armed}
      onPointerDown={(event) => {
        event.currentTarget.setPointerCapture(event.pointerId);
        startMic();
      }}
      onPointerUp={stopMic}
      onPointerCancel={stopMic}
      className={cn(
        'relative grid size-11 shrink-0 place-items-center rounded-full transition select-none',
        armed ? 'bg-accent text-white' : 'bg-raised text-muted hover:bg-hover hover:text-text',
        live && 'animate-pulse-ring',
      )}
    >
      {/* Scales with the frame's peak amplitude, so a tester can see the device is actually
          picking sound up before waiting on a transcription. */}
      {armed && (
        <span
          className="bg-accent/35 pointer-events-none absolute inset-0 rounded-full"
          style={{ transform: `scale(${1 + Math.min(level, 1) * 0.7})` }}
        />
      )}
      <Mic className="relative size-5" />
    </button>
  );
}
